module.exports = __webpack_public_path__ + "font_genshin_daughter.28288089.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/child_to_parent/font_genshin_daughter.png
// module id = 0TTT
// module chunks = 0